import { Currency } from '../../../modules/backend/openapi/api-types';

const CURRENCY_SYMBOL_MAP: Record<Currency, string> = {
  CHF: 'CHF',
  EUR: '€',
  USD: '$',
};

export function getCurrencySymbol(currency: Currency): string {
  return CURRENCY_SYMBOL_MAP[currency] || currency;
}
